import { forwardRef } from 'react';
import { oneLine } from 'common-tags';

import type { ComponentPropsWithRef, ElementType, Ref } from 'react';
import type { TypeTagsProps } from './types';

/**
 * Tags
 */
const TagBase = <T extends ElementType = 'a'>(
  {
    className = '',
    as,
    children,
    ...props
  }: TypeTagsProps<T> & Omit<ComponentPropsWithRef<T>, keyof TypeTagsProps<T>>,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ref: Ref<any>
) => {
  const HTMLTag = as || 'a';

  return (
    <HTMLTag
      className={oneLine`
        text-body text-body--primary rounded-full border border-primary-600 px-4 py-1 font-normal transition-colors first-letter:capitalize hover:bg-primary-600 hover:text-white focus:outline-0
        ${className ?? ''}
      `}
      ref={ref}
      {...props}
    >
      {children}
    </HTMLTag>
  );
};

export const Tag = forwardRef(TagBase);
